// Images
import TCSLogo_1x from "./../assets/ExperiencePage/1TCSLogo/TCSLogo_1x.webp";
import TCSLogo_2x from "./../assets/ExperiencePage/1TCSLogo/TCSLogo_2x.webp";
import TCSLogo_M1x from "./../assets/ExperiencePage/0Mobile/1Company_TCS/Company_TCS_1x.webp";
import TCSLogo_M2x from "./../assets/ExperiencePage/0Mobile/1Company_TCS/Company_TCS_2x.webp";

import CognizantLogo_1x from "./../assets/ExperiencePage/2CognizantLogo/CognizantLogo_1x.webp";
import CognizantLogo_2x from "./../assets/ExperiencePage/2CognizantLogo/CognizantLogo_2x.webp";
import CognizantLogo_M1x from "./../assets/ExperiencePage/0Mobile/2Company_Cognizant/Company_Cognizant_1x.webp";
import CognizantLogo_M2x from "./../assets/ExperiencePage/0Mobile/2Company_Cognizant/Company_Cognizant_2x.webp";

import ExtentiaLogo_1x from "./../assets/ExperiencePage/3ExtentiaLogo/ExtentiaLogo_1x.webp";
import ExtentiaLogo_2x from "./../assets/ExperiencePage/3ExtentiaLogo/ExtentiaLogo_2x.webp";
import ExtentiaLogo_M1x from "./../assets/ExperiencePage/0Mobile/3Company_Extentia/Company_Extentia_1x.webp";
import ExtentiaLogo_M2x from "./../assets/ExperiencePage/0Mobile/3Company_Extentia/Company_Extentia_2x.webp";

import WinjitLogo_1x from "./../assets/ExperiencePage/4WinjitLogo/WinjitLogo_1x.webp";
import WinjitLogo_2x from "./../assets/ExperiencePage/4WinjitLogo/WinjitLogo_2x.webp";
import WinjitLogo_M1x from "./../assets/ExperiencePage/0Mobile/4Company_Winjit/Company_Winjit_1x.webp";
import WinjitLogo_M2x from "./../assets/ExperiencePage/0Mobile/4Company_Winjit/Company_Winjit_2x.webp";

import TriarqLogo_1x from "./../assets/ExperiencePage/5TriarqLogo/TriarqLogo_1x.webp";
import TriarqLogo_2x from "./../assets/ExperiencePage/5TriarqLogo/TriarqLogo_2x.webp";
import TriarqLogo_M1x from "./../assets/ExperiencePage/0Mobile/5TriarqLogo/Company_Triarq_1x.webp";
import TriarqLogo_M2x from "./../assets/ExperiencePage/0Mobile/5TriarqLogo/Company_Triarq_2x.webp";

import ListPage from "../components/List/List";

import { useEffect } from "react";

export default function ExperienceComponent() {
  
  async function setPageHitsOnDB() {
    const url =
      "https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataExperiencePage.json";
    try {
      const response = await fetch(url);
      if (response.ok) {
        const json = await response.json();

        fetch(url, {
          method: "PUT",
          body: JSON.stringify({ pageHits: +json.pageHits + 1 }),
        });
      }
    } catch (error) {
      // console.error(error.message);
    }
  }

  useEffect(() => {
    setPageHitsOnDB();
  }, []);

  // Set Page Data
  const data = [
    {
      id: 1,
      card: {
        date: "28 NOV 2022 - PRESENT",
        title: "TATA Consultancy Services",
        subText: "Nagpur | Associate Consultant",
        image1x: TCSLogo_1x,
        image2x: TCSLogo_2x,
        imageM1x: TCSLogo_M1x,
        imageM2x: TCSLogo_M2x,
        alt: "Logo of TCS",
      },
    },
    {
      id: 2,
      card: {
        date: "2 mar 2016 - 25 nov 2022",
        title: "Cognizant Technology Solutions",
        subText: "Pune | Technology Lead",
        image1x: CognizantLogo_1x,
        image2x: CognizantLogo_2x,
        imageM1x: CognizantLogo_M1x,
        imageM2x: CognizantLogo_M2x,
        alt: "Logo of Cognizant",
      },
    },
    {
      id: 3,
      card: {
        date: "28 apr 2015 - 28 feb 2016",
        title: "Extentia Information Technology",
        subText: "Pune | Software Professional",
        image1x: ExtentiaLogo_1x,
        image2x: ExtentiaLogo_2x,
        imageM1x: ExtentiaLogo_M1x,
        imageM2x: ExtentiaLogo_M2x,
        alt: "Logo of Extentia",
      },
    },
    {
      id: 4,
      card: {
        date: "2 may 2012 - 26 mar 2015",
        title: "Winjit Technologies Pvt. Ltd.",
        subText: "Nashik | Software Developer",
        image1x: WinjitLogo_1x,
        image2x: WinjitLogo_2x,
        imageM1x: WinjitLogo_M1x,
        imageM2x: WinjitLogo_M2x,
        alt: "Logo of Winjit",
      },
    },
    {
      id: 5,
      card: {
        date: "Dec 2011 - may 2012",
        title: "Triarq Health (Formerly gloStream)",
        subText: "Nashik | Trainee Programmer (Intern)",
        image1x: TriarqLogo_1x,
        image2x: TriarqLogo_2x,
        imageM1x: TriarqLogo_M1x,
        imageM2x: TriarqLogo_M2x,
        alt: "Logo of Triarq",
      },
    },
  ];

  return <ListPage pageTitle="Corporate Experience" data={data} />;
}
